<div class="modal-header">
    <h6 class="modal-title medium">{{'resetPassword'| translate }}</h6>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="w-100 float-left">
    <div class="w-100 float-left p-4 modal-body">
        <!-- <div class="offset-lg-2 col-lg-4 col-md-4 col-sm-6 col-xs-12 pull-left cursor"> -->
        <div class="w-100 pull-left b-a relative text-center px-2 py-3 rounded light-bg">
            <i class="fa fa-check text-primary tr-0"></i>
            <p class="w-100 float-left mt-3 mb-2 medium"> {{'activationLinks'| translate }} </p>
            <h6 class="w-100 float-left"> {{'confirmToSendActivationLinkMail'| translate }}</h6>
            <!-- </div> -->
        </div>

        <br />

        <div *ngIf="passwordToken" class="w-100 pull-left b-a relative text-center px-2 py-3 rounded light-bg">
            <h6 class="w-100 float-left overflow-auto" style="overflow:auto" [copy-clipboard]="passwordToken" (copied)="notify($event)">{{passwordToken}}</h6>
        </div>
        <!-- <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 pull-left cursor" (click)="customPwd()">
            <div class="w-100 pull-left b-a relative text-center px-2 py-3 rounded light-bg">
                <p class="w-100 float-left mt-3 mb-2 medium"> Customized Password </p>
                <h6 class="w-100 float-left"> Choose a password you want users to use </h6>
            </div>
        </div> -->
    </div>
    <div class="modal-footer">
        <!-- activeModal.dismiss('Cross click') -->
        <button class="btn btn-secondary float-right" (click)="activeModal.dismiss('Cross click')"> {{'close' |
            translate}}
        </button>
        <button class="btn btn-primary float-right" (click)="resetPassword()" [disabled]="showButtonLoading">
            {{'confirm' | translate}} <i *ngIf="showButtonLoading" class="fa fa-spinner fa-spin text-white m-l-smd"></i>
        </button>
        <button class="btn btn-primary float-right" (click)="getPasswordToken()" [disabled]="showButtonLoading">
            Get password link <i *ngIf="showButtonLoading" class="fa fa-spinner fa-spin text-white m-l-smd"></i>
        </button>
    </div>
</div>

<!-- <div class="w-100 float-left" *ngIf="cp == 2">
    <div class="w-100 float-left p-4 modal-body">
        <h6 class="w-100 float-left mb-3 medium"> Customized Password </h6>
        <div class="form-group">
            <label> New password
                <span class="text-danger medium">*</span>
            </label>
            <input type="text" class="form-control w-50" placeholder="Enter new password" />
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary float-left" (click)="goBack()"> Back </button>
        <div style="flex-grow: 1;"></div>
        <button class="btn btn-secondary float-right" (click)="activeModal.dismiss('Cross click')"> Close </button>
        <button class="btn btn-primary float-right" (click)="confirmPwd()"> Reset </button>

    </div>
</div> -->

<!-- <div class="w-100 float-left" *ngIf="cp == 3">
    <div class="w-100 float-left p-4 modal-body">
        <h6 class="w-100 float-left"> Reset password was successful to the selected users. </h6>
    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary float-right" (click)="activeModal.dismiss('Cross click')"> Close </button>
    </div>
</div> -->


// WEBPACK FOOTER //
// ./src/app/employee/employeeActions/resetPasswordByAdmin.html